import { createFileRoute } from "@tanstack/react-router";
import installCss from "../install.css?url";
import landingCss from "../landing.css?url";
import legalCss from "../legal.css?url";
import { InstallPage } from "../install/InstallPage";

export const Route = createFileRoute("/install")({
  head: () => ({
    meta: [
      { title: "Install the Salesko Local Agent" },
      {
        name: "description",
        content:
          "Install the Salesko Local Agent on your Mac: one curl command, pair it with a one-time code, and run research on your own computer with your own Claude or Codex subscription."
      },
      { property: "og:title", content: "Salesko - Install the Local Agent" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://salesko.ai/install" }
    ],
    links: [
      { rel: "canonical", href: "https://salesko.ai/install" },
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      {
        rel: "stylesheet",
        href: "https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700;800&family=IBM+Plex+Mono:wght@400;500;600&family=Source+Serif+4:opsz,wght@8..60,600;8..60,700&display=swap"
      },
      { rel: "stylesheet", href: landingCss },
      { rel: "stylesheet", href: legalCss },
      { rel: "stylesheet", href: installCss }
    ]
  }),
  component: InstallPage
});
